// extracted by mini-css-extract-plugin
export default {"rootFilled":"select_rootFilled__3vf8J","filled":"select_filled__enwpA","icon":"select_icon__8ID6U","menuPaper":"select_menuPaper__hSHrU","menuList":"select_menuList__LMz1l"};